import {REQUIRED_FILES} from "../../model/requiredUploadFiles";
import {APPLICATION_ATTACHMENTS} from "../../../../utils/constants";
import React from "react";
import {Typography} from "../../../../designSystem/components/Typography";

export const NewApplicationFilesUploader = ({ category, files, onChange}) => (
  <div className="flex flex-col gap-8">
    {REQUIRED_FILES[category].map((attachmentKey: string) => (
      <div
        className="flex flex-col gap-2"
        key={APPLICATION_ATTACHMENTS[attachmentKey].label}
      >
        <Typography variant="subtitle">
          上傳{APPLICATION_ATTACHMENTS[attachmentKey].label}:
        </Typography>
        <input
          type="file"
          className="block w-full px-4 py-2 text-sm border rounded-lg cursor-pointer bg-gray-50"
          accept="image/*,application/pdf"
          onChange={e => {
            if (e.target.files && e.target.files[0]) {
              onChange({ ...files, [attachmentKey]: e.target.files[0]})
            }
          }}
        />
      </div>
    ))}
  </div>
)